export function nl2br(string){
	return string.replace(/(\r?\n)|(\n?\r)/g,'<br>');
}
